import getLatinized from '../lib/getLatinized';

const reviewers = [
    {
         sort: 'Gaworski Ireneusz',
         label: {
            pl: 'dr hab. Ireneusz Gaworski (Uniwersytet Warszawski, Polska)',
            en: 'dr hab. Ireneusz Gaworski (Uniwersytet Warszawski, Poland)',
            de: 'Dr. habil. Ireneusz Gaworski (Uniwersytet Warszawski, Polen)'
        }
    },
    {
         sort: 'Grotek Monika',
         label: {
            pl: 'dr Monika Grotek (Uniwersytet Śląski, Polska)',
            en: 'dr Monika Grotek (Uniwersytet Śląski, Poland)',
            de: 'Dr. Monika Grotek (Uniwersytet Śląski, Polen)'
        }
    },
    {
         sort: 'Baran-Łucarz Małgorzata',
         label: {
            pl: 'dr Małgorzata Baran-Łucarz (Uniwersytet Wrocławski, Polska)',
            en: 'dr Małgorzata Baran-Łucarz (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. Małgorzata Baran-Łucarz (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Jędrzejowski Łukasz',
         label: {
            pl: 'dr Łukasz Jędrzejowski (Universität zu Köln, Niemcy)',
            en: 'dr Łukasz Jędrzejowski (Universität zu Köln, Germany)',
            de: 'Dr. Łukasz Jędrzejowski (Universität zu Köln, Deutschland)'
        }
    },
    {
         sort: 'Just Anna',
         label: {
            pl: 'dr hab. Anna Just, prof. UW (Uniwersytet Warszawski, Polska)',
            en: 'prof. dr hab. Anna Just (Uniwersytet Warszawski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Anna Just (Uniwersytet Warszawski, Polen)'
        }
    },
    {
         sort: 'Klockmann Heidi Elisabeth',
         label: {
            pl: 'prof. Heidi Elisabeth Klockmann (Universitetet i Agder, Norwegia)',
            en: 'prof. Heidi Elisabeth Klockmann (Universitetet i Agder, Norway)',
            de: 'Prof. Assoc. Heidi Elisabeth Klockmann (Universitetet i Agder, Norwegen)'
        }
    },
    {
         sort: 'Malak Janusz',
         label: {
            pl: 'dr hab. Janusz Malak, prof. UO (Uniwersytet Opolski, Polska)',
            en: 'dr hab. Janusz Malak, prof. UO (Uniwersytet Opolski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Janusz Malak (Uniwersytet Opolski, Polen)'
        }
    },
    {
         sort: 'Morciniec Norbert',
         label: {
            pl: 'prof. dr hab. Norbert Morciniec (Uniwersytet Wrocławski, Polska)',
            en: 'prof. dr hab. Norbert Morciniec (Uniwersytet Wrocławski, Poland)',
            de: 'Prof. Dr. habil. Norbert Morciniec (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Ruda Marta',
         label: {
            pl: 'dr Marta Ruda (Uniwersytet Jagielloński w Krakowie, Polska)',
            en: 'dr Marta Ruda (Uniwersytet Jagielloński w Krakowie, Poland)',
            de: 'Dr. Marta Ruda (Uniwersytet Jagielloński w Krakowie, Polen)'
        }
    },
    {
         sort: 'Rytel-Schwarz Danuta',
         label: {
            pl: 'prof. Danuta Rytel-Schwarz (Universität Leipzig, Niemcy)',
            en: 'prof. Danuta Rytel-Schwarz (Universität Leipzig, Germany)',
            de: 'Univ.-Prof. Dr. habil. Danuta Rytel-Schwarz (Universität Leipzig, Deutschland)'
        }
    },
    {
         sort: 'Schatte Czesława',
         label: {
            pl: 'prof. Czesława Schatte (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            en: 'prof. Czesława Schatte (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            de: 'Univ.-Prof. Dr. habil. Czesława Schatte (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polen)'
        }
    },
    {
         sort: 'Szczepaniak Jacek',
         label: {
            pl: 'dr hab. Jacek Szczepaniak, prof. ucz. (Uniwersytet Kazimierza Wielkiego w Bydgoszczy, Polska)',
            en: 'dr hab. Jacek Szczepaniak, prof. ucz. (Uniwersytet Kazimierza Wielkiego w Bydgoszczy, Poland)',
            de: 'Univ.-Prof. Dr. habil. Jacek Szczepaniak (Uniwersytet Kazimierza Wielkiego w Bydgoszczy, Polen)'
        }
    },
    {
         sort: 'Szczesniak Konrad',
         label: {
            pl: 'dr hab. Konrad Szczesniak, prof. UŚ (Uniwersytet Śląski, Polska)',
            en: 'dr hab. Konrad Szczesniak, prof. UŚ (Uniwersytet Śląski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Konrad Szczesniak (Uniwersytet Śląski, Polen)'
        }
    },
    {
         sort: 'Taborek Janusz',
         label: {
            pl: 'prof. dr hab. Janusz Taborek (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polska)',
            en: 'prof. dr hab. Janusz Taborek (Uniwersytet im. Adama Mickiewicza w Poznaniu, Poland)',
            de: 'Prof. Dr. habil. Janusz Taborek (Uniwersytet im. Adama Mickiewicza w Poznaniu, Polen)'
        }
    },
    {
         sort: 'Vinckel-Roisin Hélène',
         label: {
            pl: 'prof. dr hab. Hélène Vinckel-Roisin (Université de Lorraine, Francja)',
            en: 'prof. dr hab. Hélène Vinckel-Roisin (Université de Lorraine, France)',
            de: 'Prof. Dr. habil. Hélène Vinckel-Roisin (Université de Lorraine, Frankreich)'
        }
    },
    {
         sort: 'Woźny Jacek',
         label: {
            pl: 'dr Jacek Woźny (Uniwersytet Wrocławski, Polska)',
            en: 'dr Jacek Woźny (Uniwersytet Wrocławski, Poland)',
            de: 'Dr. Jacek Woźny (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Gattnar Anja',
         label: {
            pl: 'dr Anja Gattnar (Universität Tübingen, Niemcy)',
            en: 'dr Anja Gattnar (Universität Tübingen, Germany)',
            de: 'Dr. Anja Gattnar (Universität Tübingen, Deutschland)'
        }
    },
    {
         sort: 'Szawerna Michał',
         label: {
            pl: 'dr hab. Michał Szawerna, prof. UWr (Uniwersytet Wrocławski, Polska)',
            en: 'dr hab. Michał Szawerna, prof. UWr (Uniwersytet Wrocławski, Poland)',
            de: 'Univ.-Prof. Dr. habil. Michał Szawerna (Uniwersytet Wrocławski, Polen)'
        }
    },
    {
         sort: 'Szurawitzki Michael',
         label: {
            pl: 'prof. dr hab. Michael Szurawitzki (Brandenburgische Technische Universität Cottbus-Senftenberg, Niemcy)',
            en: 'prof. dr hab. Michael Szurawitzki (Brandenburgische Technische Universität Cottbus-Senftenberg, Germany)',
            de: 'Prof. Dr. phil. habil. Michael Szurawitzki (Brandenburgische Technische Universität Cottbus-Senftenberg, Deutschland)'
        }
    }
].sort((a, b) =>
    getLatinized((a.sort).toLowerCase()) >
    getLatinized((b.sort).toLowerCase()) ? 1 : -1
);

export default reviewers;
